/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded/EntryType/AppliedPayment/Content/UnappliedAt/Content"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let entryTransactionAppliedPaymentUnappliedPaymentTransactionSysCreatedValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'transaction.applied_payment.unapplied_payment.transaction.sys_created',
format: fromFormat.dateShortWithMonthAndTime,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Unapplied at"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="entry.transaction.applied_payment.unapplied_payment.transaction.sys_created"
 format="/Data/format.js dateShortWithMonthAndTime"
 text={entryTransactionAppliedPaymentUnappliedPaymentTransactionSysCreatedValueData}
/>
</div>
{children}
</React.Fragment>)
}